import VueRouter from 'vue-router'
import Vue from 'vue'
import firebase from '../Firebase'

import ShowPost from '@/components/ShowPost'
import AddPost from '@/components/AddPost'
import EditPost from '@/components/EditPost'
import MemberList from '@/components/MemberList'
import Dashboard from '@/components/Dashboard'
import AddMember from '@/components/AddMember'
import EditMember from '@/components/EditMember'
import ShowMember from '@/components/ShowMember'
import Login from '@/components/Login'
import AddEvent from '@/components/AddEvent'
import ShowEvent from '@/components/ShowEvent'
import EditEvent from '@/components/EditEvent'

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  hash: false,
    routes: [
    {
      path: '*',
      redirect: '/login'
    },
    {
      path: '/',
      redirect: '/login'
    },
      {
        path: '/login',
        name: 'Login',
        component: Login
      },
      {
        path: '/dashboard',
        name: 'Dashboard',
        component: Dashboard,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/show-post/:id',
        name: 'ShowPost',
        component: ShowPost,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/add-post',
        name: 'AddPost',
        component: AddPost,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/edit-post/:id',
        name: 'EditPost',
        component: EditPost,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/member-list',
        name: 'MemberList',
        component: MemberList,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/add-member',
        name: 'AddMember',
        component: AddMember,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/show-member/:id',
        name: 'ShowMember',
        component: ShowMember,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/edit-member/:id',
        name: 'EditMember',
        component: EditMember,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/add-event',
        name: 'AddEvent',
        component: AddEvent,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/show-event/:id',
        name: 'ShowEvent',
        component: ShowEvent,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/edit-event/:id',
        name: 'EditEvent',
        component: EditEvent,
        meta: {
          requiresAuth: true
        }
      }
    ]
  });

  firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION);

  router.beforeEach((to, from, next) => {
    const currentUser = firebase.auth().currentUser;
    const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

    if (requiresAuth && !currentUser) next('Login');
    else if (!requiresAuth && currentUser) next('Dashboard');
    else next();
  });

export default router;